import React, { useMemo, useState, useEffect, useRef } from 'react';
import { BORDER_RADIUS_OPTIONS, ClassEnum } from '@/constants/enum';
import IconCheck from '@/asset/icons/check';
import IconDropdownExpand from '@/asset/icons/dropdown-expand';
import CloseIcon from '@/asset/icons/close-icon';
import { handleSavePreviewDateTimeSettings } from '@/redux/slice/previewDateTime.slice';
import { useAppDispatch } from '@/redux/store';

interface IProps {
  options: {
    value: string;
    label: React.ReactNode;
  }[];
  value?: string;
  onChange: (value: string) => void;
  borderRadius?: BORDER_RADIUS_OPTIONS;
  labelPrefix?: React.ReactNode;
  styles?: {
    button?: React.CSSProperties;
    label?: React.CSSProperties;
    content?: React.CSSProperties;
    contentItem?: React.CSSProperties;
  };
  style?: React.CSSProperties;
  placeHolder?: React.ReactNode;
  isDisabled?: boolean;
  color?: string;
  backgroundColor?: string;
  iconDropdownExpandOpacity?: number;
  isClearable?: boolean;
}

const Dropdown = (props: IProps) => {
  const [isShowContent, setIsShowContent] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  console.log(props.iconDropdownExpandOpacity, 'IconDropdownExpand');

  const selectedOption = useMemo(
    () => props.options.find((option) => option.value === props.value),
    [props.options, props.value],
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsShowContent(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className={ClassEnum.Dropdown} style={props.style}>
      <div
        id="fulfillment-method-select"
        className={ClassEnum.DropdownButton + ' ' + (props.isDisabled ? ClassEnum.Disabled : '')}
        style={{
          borderRadius: props.borderRadius,
          color: props.color,
          backgroundColor: props.backgroundColor,
          ...props.styles?.button,
        }}
        onClick={() => !props.isDisabled && setIsShowContent(!isShowContent)}
      >
        <div className={ClassEnum.DropdownLabelContainer}>
          {props.labelPrefix ? props.labelPrefix : null}

          <div className={ClassEnum.DropdownLabel} style={props.styles?.label}>
            {selectedOption ? selectedOption.label : props.placeHolder || null}
          </div>
        </div>
        <div
          className={ClassEnum.DropdownButtonIcon}
          onClick={(e) => {
            if (!props.value || !props.isClearable) return;
            e.stopPropagation();
            if (isShowContent) {
              setIsShowContent(false);
            }
            dispatch(handleSavePreviewDateTimeSettings({ selectedTime: undefined }));
          }}
        >
          {props.value && props.isClearable ? <CloseIcon /> : <IconDropdownExpand />}
        </div>
      </div>
      {isShowContent ? (
        <div
          className={ClassEnum.DropdownContent}
          style={{
            animation: 'dropdown 0.3s',
            borderRadius: props.borderRadius,
            color: props.color,
            backgroundColor: props.backgroundColor,
            ...props.styles?.content,
          }}
        >
          {props.options.map((option) => (
            <div
              className={ClassEnum.DropdownContentItem}
              style={{
                borderRadius: props.borderRadius,
                color: props.color,
                backgroundColor: props.backgroundColor,
                ...props.styles?.contentItem,
              }}
              key={option.value}
              onClick={() => {
                props.onChange(option.value);
                setIsShowContent(false);
              }}
            >
              <div>{option.label}</div>
              {option.value === props.value ? <IconCheck /> : null}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default Dropdown;
